import { Button, DownloadSimpleIcon } from "@stacklet/ui";

interface Props {
  handleExport: () => void;
  exportInProgress: boolean;
}

export function XGridCustomToolbarExport({
  handleExport,
  exportInProgress,
}: Props) {
  return (
    <Button
      IconLeft={<DownloadSimpleIcon size={20} />}
      aria-label="Export"
      isDisabled={exportInProgress}
      onPress={handleExport}
      variant="tertiary"
    >
      Export
    </Button>
  );
}
